/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The ItemModifier model module.
* @module model/ItemModifier
* @version 1.0.0
*/
export default class ItemModifier {
    /**
    * Constructs a new <code>ItemModifier</code>.
    * @alias module:model/ItemModifier
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>ItemModifier</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ItemModifier} obj Optional instance to populate.
    * @return {module:model/ItemModifier} The populated <code>ItemModifier</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemModifier();
                        
            
            if (data.hasOwnProperty('Id')) {
                obj['Id'] = ApiClient.convertToType(data['Id'], 'String');
            }
            if (data.hasOwnProperty('OnByDefault')) {
                obj['OnByDefault'] = ApiClient.convertToType(data['OnByDefault'], 'Boolean');
            }
        }
        return obj;
    }

    /**
    * @member {String} Id
    */
    'Id' = undefined;
    /**
    * @member {Boolean} OnByDefault
    */
    'OnByDefault' = undefined;




}
